<lib-sales-insights-card
  [cardTitle]="config?.title"
  [subtitle]="subtitle"
  [loading]="loading"
  [error]="error"
  [empty]="empty"
>
  @if (canExport) {
    <button
      cardActions
      type="button"
      class="btn btn-sm si-table__export"
      [disabled]="exporting"
      (click)="exportExcel()"
    >
      <i class="fa-solid fa-file-excel me-1"></i>{{ 'SALES_INSIGHTS_EXPORT_EXCEL' | translate }}
    </button>
  }
  @if (searchable) {
    <lib-sales-insights-list-search cardToolbar [value]="query" (valueChange)="search($event)"></lib-sales-insights-list-search>
  }
  <div class="table-responsive si-table">
    <table class="table table-sm table-hover align-middle mb-0">
      <thead>
        <tr>
          <th scope="col" class="si-table__sortable" (click)="sortBy('name')">
            {{ nameHeader }}
            <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'name' }"></ng-container>
          </th>
          @for (column of measureColumns; track column) {
            <th scope="col" class="si-table__sortable text-end" (click)="sortBy(column)">
              {{ columnLabelKey(column) | translate }}
              <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: column }"></ng-container>
            </th>
          }
          @if (compares) {
            <th scope="col" class="text-end">{{ 'SALES_INSIGHTS_COL_PREVIOUS' | translate }}</th>
            <th scope="col" class="text-end">{{ 'SALES_INSIGHTS_COL_CHANGE' | translate }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track row.key) {
          <tr [class.si-table__others]="row.key === othersKey">
            <td class="si-table__name">
              <span class="text-truncate">{{ displayName(row) }}</span>
              @if (showsCode(row)) {
                <span class="si-table__key">{{ row.key }}</span>
              }
            </td>
            @for (column of measureColumns; track column) {
              <td class="text-end si-table__number">
                {{ formatAmount(row[column]) }}
                @if (column === 'valueLocal' && row.currency) {
                  <span class="si-table__key">{{ row.currency }}</span>
                }
              </td>
            }
            @if (compares) {
              <td class="text-end si-table__number si-table__previous">{{ formatAmount(previousValue(row)) }}</td>
              <td class="text-end si-table__number">
                @if (change(row); as delta) {
                  <span
                    class="si-table__delta"
                    [class.si-table__delta--up]="delta.direction === 'up'"
                    [class.si-table__delta--down]="delta.direction === 'down'"
                  >{{ delta.text }}</span>
                }
              </td>
            }
          </tr>
        } @empty {
          <tr>
            <td [attr.colspan]="columnCount" class="text-body-secondary">{{ 'SALES_INSIGHTS_LIST_NO_MATCHES' | translate }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</lib-sales-insights-card>

<ng-template #sortIcon let-column>
  @if (sortColumn === column) {
    <i
      class="fa-solid ms-1"
      [class.fa-arrow-up-short-wide]="sortDirection === 'asc'"
      [class.fa-arrow-down-wide-short]="sortDirection === 'desc'"
    ></i>
  }
</ng-template>
